// =============================================================================
// MeuDriver — Página de cidade (SEO): /instrutores-de-direcao/:uf/:cidade
// Ex.: /instrutores-de-direcao/mg/belo-horizonte. Mesma busca da /instrutores,
// já filtrada, com título e texto da cidade. Listada no sitemap.xml
// (scripts/gerar-sitemap.mjs) para as cidades que têm instrutor aprovado.
// =============================================================================

import { useParams } from 'react-router-dom'
import InstructorsPage from './InstructorsPage'

export default function CityInstructorsPage() {
  const { uf = '', cidade = '' } = useParams<{ uf: string; cidade: string }>()
  return <InstructorsPage landing={{ uf, citySlug: cidade.toLowerCase() }} />
}
